import { urls } from "venuescanner-js/services/endPoints";
/** @class
 * @name SpaceSdp
 * @desc Class definition of a Space - schema defined in venuescanner-js/schemas/serviceSchema.json
 * @param {Object} [values={}] - The values to apply to the model
 */
class SpaceSdp {
  constructor(values = {}) {
    // console.log(values)
    Object.keys(values).forEach((key) => {
      this[key] = values[key];
    });
    if (typeof this.capacity === "string") {
      try {
        this.capacity = JSON.parse(this.capacity);
      } catch (_e) {}
    }
  }

  /** @function
   * @memberof SpaceSdp
   * @name photoURLs
   * @param {string} size - Defaults to min
   * @desc Returns the photo URLs
   * @returns {string[]}
   */
  photoURLs(size = "min") {
    if (this.photos.length) {
      return this.photos.map((p) =>
        p.path.replace(p.filename, `${size}_${p.filename}`)
      );
    }
    return [];
  }

  /** @function
   * @memberof SpaceSdp
   * @name sdp
   * @desc Returns the URL of the SDP
   * @returns {string}
   */
  sdp() {
    return `${urls.RAILS_URL}${this.url}`;
  }
}

export default SpaceSdp;
